/**
 * mwApp.home module <br>
 * Dashboard, system info
 *
 * @namespace mwApp/home
 */

import DashboardCtrl from './dashboard.controller'
import DashboardSetupCtrl from './dashboardSetup.controller'
import homeConfig from './home.config'
import * as dashboardDirectives from './dashboard.directives'

export default
angular.module('mwApp.home', [])
  .config(homeConfig)
  .directive('dashboardMap', dashboardDirectives.dashboardMap)
  .directive('dashboardChartLine', dashboardDirectives.dashboardChartLine)
  .controller('DashboardCtrl', DashboardCtrl)
  .controller('DashboardSetupCtrl', DashboardSetupCtrl)
